import React, { useEffect, useState, useRef } from "react";
import api from "@/services/api";
import { toast } from "react-hot-toast";
import { MdSend, MdClear, MdDescription, MdOutlineContentCopy, MdFilterList, MdLightbulb, MdAutoAwesome, MdLibraryBooks } from "react-icons/md";

const Claude = ({ answer, setAnswer }) => {
  // Bibliothèque de prompts prédéfinis
  const promptLibrary = [
    {
      id: "default",
      label: "Question personnalisée",
      text: "Posez votre question sur la mission AO…",
    },
    {
      id: "analyse-initiale",
      label: "1. Analyse initiale de l'AO",
      text: "En tant qu'expert en réponse aux appels d'offres, analyse méthodiquement ce cahier des charges. Pense étape par étape:\n\n1) Identifie les besoins techniques explicites (fonctionnalités essentielles, performance attendue, contraintes techniques, intégrations requises, exigences de sécurité)\n\n2) Détecte les besoins implicites et points d'attention cachés entre les lignes\n\n3) Évalue l'environnement technique du client (infrastructure probable, maturité digitale, contraintes spécifiques)\n\n4) Détermine les critères de différenciation et facteurs de succès pour gagner cet AO\n\n5) Formule les questions stratégiques à poser au client pour clarifier les zones d'ombre\n\nTermine par une synthèse structurée des éléments clés qui serviront de base à une réponse gagnante.",
    },
    {
      id: "architecture-technique",
      label: "2. Architecture technique",
      text: "En tant qu'architecte technique senior, conçois une architecture technique exceptionnelle pour ce projet web qui impressionnera le client. Pense étape par étape:\n\n1) Justifie une stack technologique moderne et pertinente (front-end, back-end, base de données) en expliquant pourquoi ces choix sont supérieurs aux alternatives\n\n2) Décris précisément l'architecture système (composants, interactions, flux de données) avec ses avantages concrets\n\n3) Explique la stratégie d'infrastructure et d'hébergement (cloud/serveurs) optimale pour ce contexte spécifique\n\n4) Détaille les mécanismes de scalabilité, performance et résilience qui garantiront une application robuste\n\n5) Mets en avant les aspects innovants et différenciants de cette architecture par rapport aux solutions classiques\n\nIllustre tes explications par des exemples concrets et des arguments techniques précis qui démontrent ta maîtrise et convaincront le client que cette architecture est la meilleure possible pour son projet.",
    },
    {
      id: "methodologie",
      label: "3. Méthodologie de développement",
      text: "En tant que directeur de projets expérimenté, présente une méthodologie de développement sur mesure qui impressionnera le client par sa rigueur et son efficacité. Pense étape par étape:\n\n1) Décris une approche agile parfaitement adaptée à ce projet spécifique (organisation des sprints, cérémonies, livrables, communication client)\n\n2) Détaille un processus d'assurance qualité rigoureux avec des exemples concrets (stratégie de tests, automatisation, métriques, seuils de qualité)\n\n3) Explique comment tu intègreras le client et les utilisateurs finaux tout au long du processus pour garantir l'adéquation aux besoins\n\n4) Présente une stratégie de gestion des risques projet avec identification précoce et plan de mitigation\n\n5) Décris les outils et processus spécifiques que tu mettras en place pour assurer la transparence et la visibilité sur l'avancement\n\nConcluez en expliquant pourquoi cette méthodologie représente un avantage concurrentiel majeur par rapport aux approches standards du marché, en utilisant des exemples de succès passés similaires.",
    },
    {
      id: "securite-conformite",
      label: "4. Sécurité et conformité",
      text: "En tant qu'expert en cybersécurité et conformité, développe une stratégie complète qui rassurera pleinement le client sur ces aspects critiques. Pense étape par étape:\n\n1) Présente une architecture de sécurité multicouche spécifique à ce projet (protection infrastructure, application, données, accès) avec justifications techniques précises\n\n2) Détaille le processus complet de sécurisation du développement (secure coding, tests, audits, protection contre OWASP Top 10) avec exemples concrets\n\n3) Explique ta stratégie complète de conformité réglementaire (RGPD, standards sectoriels, accessibilité) et comment elle sera mise en œuvre et documentée\n\n4) Décris le plan de gestion des incidents de sécurité et de continuité d'activité adapté à ce contexte particulier\n\n5) Présente les certifications, méthodologies et outils spécifiques qui seront utilisés pour garantir un niveau de sécurité optimal\n\nConclus en expliquant pourquoi cette approche offre des garanties supérieures aux standards du marché et représente un atout différenciant pour remporter cet appel d'offres.",
    },
    {
      id: "maintenance-support",
      label: "5. Maintenance et support",
      text: "En tant que responsable des opérations et de la satisfaction client, conçois une stratégie de maintenance et support exceptionnelle pour ce projet. Pense étape par étape:\n\n1) Élabore une offre de support premium avec des SLA précis et ambitieux (temps de réponse, résolution, disponibilité) adaptés aux enjeux du projet\n\n2) Détaille l'organisation de l'équipe support dédiée (rôles, processus, outils) et son intégration avec les équipes de développement pour une efficacité maximale\n\n3) Présente une stratégie proactive de maintenance (monitoring, alertes, maintenance préventive) qui minimise les incidents et maximise la disponibilité\n\n4) Explique le processus d'évolution continue de l'application (mises à jour, nouvelles fonctionnalités, optimisations) avec exemples de roadmap\n\n5) Décris les outils de reporting et de communication qui seront mis en place pour assurer une transparence totale avec le client\n\nTermine en quantifiant les bénéfices concrets de cette approche (réduction des incidents, amélioration de la performance, économies réalisées) pour démontrer sa valeur exceptionnelle comme facteur différenciant de ton offre.",
    },
    {
      id: "innovation-performance",
      label: "6. Innovation et performance",
      text: "En tant qu'expert en technologies émergentes et optimisation, propose des solutions innovantes et performantes qui feront la différence dans cet AO. Pense étape par étape:\n\n1) Identifie 3-5 technologies ou approches innovantes parfaitement adaptées à ce projet spécifique (ex: PWA, Edge Computing, IA, etc.) et justifie précisément leur pertinence et valeur ajoutée\n\n2) Pour chaque innovation, détaille un cas d'usage concret avec les bénéfices quantifiables pour les utilisateurs et le client\n\n3) Développe une stratégie d'optimisation des performances complète (front-end, back-end, réseau, base de données) avec objectifs chiffrés et méthodes de mesure\n\n4) Explique comment ces innovations seront implémentées sans risque, avec une approche progressive et maîtrisée\n\n5) Présente des exemples de projets similaires où ces technologies ont créé une valeur exceptionnelle\n\nConclus en expliquant pourquoi ces innovations constituent un avantage concurrentiel décisif pour ce projet, tout en restant pragmatique et axé sur la valeur business réelle plutôt que sur la technologie pour elle-même.",
    },
    {
      id: "aspects-commerciaux",
      label: "7. Aspects commerciaux",
      text: "En tant que directeur commercial expérimenté dans les projets digitaux, élabore une proposition financière et temporelle optimale pour cet AO. Pense étape par étape:\n\n1) Structure un modèle de coûts transparent et justifié, détaillant précisément chaque poste de dépense (développement, licences, infrastructure, maintenance) avec ses bénéfices associés\n\n2) Propose un phasage intelligent du projet qui optimise le time-to-market et le ROI, avec des livrables intermédiaires à forte valeur ajoutée\n\n3) Développe une stratégie de tarification qui démontre un excellent rapport qualité-prix tout en évitant de sous-valoriser ton offre, avec des options modulaires pertinentes\n\n4) Présente un planning réaliste mais ambitieux, identifiant clairement les jalons, les livrables et les responsabilités, avec les ressources associées\n\n5) Intègre des garanties commerciales différenciantes (engagements de résultats, bonus/malus, garanties étendues) qui démontrent ta confiance dans la qualité de ton offre\n\nConclus en calculant le ROI prévisionnel pour le client et en montrant comment ton approche commerciale représente le meilleur compromis entre qualité, sécurité, coût et délai.",
    },
    {
      id: "differenciateurs",
      label: "8. Différenciateurs clés",
      text: 'En tant que stratège en réponse aux appels d\'offres, identifie et développe les arguments différenciateurs qui feront gagner cet AO. Pense étape par étape:\n\n1) Analyse les forces uniques et distinctives de ton entreprise par rapport à la concurrence probable sur cet AO (expertise technique, méthodologie, expériences similaires, équipe)\n\n2) Identifie les points de douleur et préoccupations principales du client qui transparaissent dans le cahier des charges, et explique comment ton approche y répond parfaitement\n\n3) Développe 3-5 arguments différenciateurs forts, spécifiques et quantifiables, en évitant les généralités ("qualité", "expertise") pour se concentrer sur des avantages concrets et uniques\n\n4) Pour chaque différenciateur, fournis des preuves tangibles (références similaires, expertise documentée, innovations brevetées, certifications exclusives)\n\n5) Explique comment ta proposition minimise les risques pour le client grâce à des mesures spécifiques (méthodologie éprouvée, plan de continuité, garanties contractuelles)\n\nConclus en présentant une vision synthétique et convaincante de pourquoi ton offre représente le meilleur choix pour ce client, en répondant précisément à ses besoins explicites et implicites.',
    },
    {
      id: "retroplanning",
      label: "9. Rétroplanning détaillé",
      text: "En tant que chef de projet senior, élabore un rétroplanning détaillé et optimisé pour ce projet web. Pense étape par étape en partant de la date de livraison finale:\n\n1) Identifie les jalons critiques et les dates clés (mise en production, recette, développement, conception) en tenant compte des contraintes sectorielles et des bonnes pratiques\n\n2) Pour chaque phase majeure (cadrage, conception, développement, tests, déploiement), détaille les activités principales, leur durée estimée, les dépendances et le chemin critique\n\n3) Alloue les ressources humaines nécessaires à chaque étape en identifiant les profils clés et leurs responsabilités précises\n\n4) Intègre des points de contrôle stratégiques (validation client, revues qualité, tests) et des marges de sécurité aux endroits critiques\n\n5) Anticipe les risques calendaires potentiels et prévois des plans de contingence pour chacun\n\nPrésente ce planning sous forme structurée avec les justifications de tes choix, montrant comment cette planification optimise le rapport qualité/délai tout en minimisant les risques. Inclus des recommandations sur les éléments du planning à mettre en avant dans ta réponse à l'AO.",
    },
    {
      id: "analyse-reponse",
      label: "10. Analyse critique de ma réponse",
      text: "En tant que consultant expert en réponse aux appels d'offres, analyse ma proposition actuelle et identifie comment la transformer en offre gagnante. Pense étape par étape:\n\n1) Évalue objectivement les points forts de ma réponse qui doivent être davantage mis en valeur et explique comment les amplifier efficacement\n\n2) Identifie précisément les faiblesses, incohérences ou insuffisances qui pourraient réduire mes chances de succès, avec des exemples concrets\n\n3) Repère les éléments essentiels manquants par rapport aux standards du secteur et aux attentes habituelles dans ce type d'AO\n\n4) Analyse la structure et la présentation globale de ma réponse (clarté, hiérarchisation, mise en page, éléments visuels) et propose des améliorations concrètes\n\n5) Suggère 3-5 éléments différenciants stratégiques à intégrer ou renforcer pour me démarquer clairement de la concurrence\n\nConclus par un plan d'action prioritaire avec les modifications les plus impactantes à mettre en œuvre pour maximiser mes chances de gagner cet appel d'offres, en justifiant chaque recommandation par son impact potentiel.",
    },
  ];

  const [selectedPromptId, setSelectedPromptId] = useState("default");
  const [question, setQuestion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [showPromptLibrary, setShowPromptLibrary] = useState(false);
  const [fileFilter, setFileFilter] = useState("");
  const [showFileSelector, setShowFileSelector] = useState(false);
  
  // Nouvelles variables d'état pour les connaissances
  const [knowledgeItems, setKnowledgeItems] = useState([]);
  const [selectedKnowledge, setSelectedKnowledge] = useState([]);
  const [showKnowledgeSelector, setShowKnowledgeSelector] = useState(false);
  const [knowledgeFilter, setKnowledgeFilter] = useState("");
  
  const chatEndRef = useRef(null);
  const textareaRef = useRef(null);

  // Charger les documents disponibles
  useEffect(() => {
    if (answer?._id) {
      fetchFiles();
      fetchKnowledge();
    }
  }, [answer]);
  
  // Scroll to bottom when chat history updates
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatHistory]);
  
  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 200) + "px";
    }
  }, [question]);

  const fetchFiles = async () => {
    try {
      const { ok, data } = await api.post(`/mission_ao_file/search`, {
        mission_ao_answer_id: answer._id,
        limit: 1000,
      });
      if (!ok) throw new Error("Failed to fetch files");
      setFiles(data);
    } catch (error) {
      console.error("Error fetching files:", error);
      toast.error("Erreur lors du chargement des documents");
    }
  };

  // Charger les connaissances disponibles
  const fetchKnowledge = async () => {
    try {
      const { ok, data } = await api.post(`/mission_ao_knowledge/search`, {
        mission_ao_answer_id: answer._id,
      });
      if (!ok) throw new Error("Failed to fetch knowledge");
      setKnowledgeItems(data);
    } catch (error) {
      console.error("Error fetching knowledge:", error);
    }
  };

  // Gestion du changement de prompt
  const handlePromptChange = (promptId) => {
    setSelectedPromptId(promptId);
    const selectedPrompt = promptLibrary.find((prompt) => prompt.id === promptId);
    setQuestion(selectedPrompt.text);
    setShowPromptLibrary(false);
    
    if (textareaRef.current) {
      setTimeout(() => {
        textareaRef.current.focus();
      }, 100);
    }
  };

  // Gestion de la sélection des fichiers
  const handleFileSelection = (fileId) => {
    setSelectedFiles((prevSelectedFiles) => {
      if (prevSelectedFiles.includes(fileId)) {
        return prevSelectedFiles.filter((id) => id !== fileId);
      } else {
        return [...prevSelectedFiles, fileId];
      }
    });
  };
  
  // Gestion de la sélection des connaissances
  const handleKnowledgeSelection = (knowledgeId) => {
    setSelectedKnowledge((prevSelected) => {
      if (prevSelected.includes(knowledgeId)) {
        return prevSelected.filter((id) => id !== knowledgeId);
      } else {
        return [...prevSelected, knowledgeId];
      }
    });
  };
  
  // Sélectionner tous les fichiers
  const handleSelectAllFiles = () => {
    if (selectedFiles.length === filteredFiles.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(filteredFiles.map(file => file._id));
    }
  };
  
  // Sélectionner toutes les connaissances
  const handleSelectAllKnowledge = () => {
    if (selectedKnowledge.length === filteredKnowledge.length) {
      setSelectedKnowledge([]);
    } else {
      setSelectedKnowledge(filteredKnowledge.map(item => item._id));
    }
  };

  // Filtrer les fichiers
  const filteredFiles = fileFilter 
    ? files.filter(file => file.label.toLowerCase().includes(fileFilter.toLowerCase()))
    : files;

  // Filtrer les connaissances
  const filteredKnowledge = knowledgeFilter 
    ? knowledgeItems.filter(item => 
        item.label.toLowerCase().includes(knowledgeFilter.toLowerCase()) ||
        (item.tags && item.tags.some(tag => tag.toLowerCase().includes(knowledgeFilter.toLowerCase())))
      )
    : knowledgeItems;

  async function handleAsk() {
    try {
      if (!question.trim()) return;

      setIsLoading(true);
      
      // Ajouter la question à l'historique du chat
      const selectedFileObjects = selectedFiles.length > 0 
        ? files.filter(file => selectedFiles.includes(file._id))
        : [];
      
      const selectedKnowledgeObjects = selectedKnowledge.length > 0
        ? knowledgeItems.filter(item => selectedKnowledge.includes(item._id))
        : [];
      
      const newQuestion = {
        type: "question",
        content: question,
        files: selectedFileObjects.map(file => ({
          id: file._id,
          label: file.label
        })),
        knowledge: selectedKnowledgeObjects.map(item => ({
          id: item._id,
          label: item.label
        })),
        timestamp: new Date()
      };
      
      setChatHistory(prev => [...prev, newQuestion]);
      
      const obj = { question };
      if (answer._id) obj.answer_id = answer._id;
      
      // Ajouter les fichiers sélectionnés à la requête
      if (selectedFiles.length > 0) {
        obj.files = selectedFileObjects.map(file => ({
          url: file.url,
          label: file.label
        }));
      }
      
      // Ajouter les connaissances sélectionnées à la requête
      if (selectedKnowledge.length > 0) {
        obj.knowledge_ids = selectedKnowledge;
      }

      const { ok, data, code } = await api.post("/mission_ao_answer/ask", obj);
      if (!ok) {
        toast.error("Une erreur est survenue lors de la requête à Claude");
        console.error(`Error - Code: ${code}`);
        return;
      }
      
      // Ajouter la réponse à l'historique du chat
      setChatHistory(prev => [...prev, {
        type: "answer",
        content: data,
        timestamp: new Date()
      }]);
      
      // Réinitialiser le formulaire pour une nouvelle question
      setQuestion("");
      setShowFileSelector(false);
      setShowKnowledgeSelector(false);
      
    } catch (error) {
      console.error("Failed to get answer:", error);
      toast.error("Une erreur est survenue");
    } finally {
      setIsLoading(false);
    }
  }
  
  // Gérer la touche Enter pour envoyer
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAsk();
    }
  };
  
  // Effacer l'historique
  const clearHistory = () => {
    if (confirm("Êtes-vous sûr de vouloir effacer tout l'historique de conversation?")) {
      setChatHistory([]);
    }
  };

  return (
    <div className="h-[calc(100vh-160px)] flex flex-col bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-3 flex justify-between items-center shadow-sm">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white mr-3 shadow-md">
            <MdAutoAwesome className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Claude</h2>
            <p className="text-xs text-gray-500">Assistant IA pour Appels d'Offres</p>
          </div>
        </div>

        {chatHistory.length > 0 && (
          <button 
            onClick={clearHistory}
            className="text-sm text-gray-500 hover:text-gray-700 flex items-center px-3 py-1 rounded-full hover:bg-gray-100 transition-all"
          >
            <MdClear className="mr-1" /> Effacer
          </button>
        )}
      </div>
      
      {/* Chat Area */}
      <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-6">
        {chatHistory.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-center p-6">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mb-6 shadow-lg">
              <MdAutoAwesome className="h-10 w-10 text-white" />
            </div>
            <h3 className="text-xl font-medium text-gray-900 mb-3">Bienvenue sur Claude</h3>
            <p className="text-gray-600 max-w-md mb-6">
              Posez des questions sur votre appel d'offres et sélectionnez des documents à analyser pour obtenir des réponses pertinentes.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl w-full">
              <button 
                onClick={() => setShowPromptLibrary(true)}
                className="flex items-center justify-center p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all text-left"
              >
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                  <MdLightbulb className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Utiliser un prompt</h4>
                  <p className="text-sm text-gray-500">Choisissez parmi nos modèles prédéfinis</p>
                </div>
              </button>
              
              <button 
                onClick={() => setShowFileSelector(true)}
                className="flex items-center justify-center p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all text-left"
              >
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                  <MdDescription className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Analyser des documents</h4>
                  <p className="text-sm text-gray-500">Sélectionnez des fichiers à analyser</p>
                </div>
              </button>
              
              <button 
                onClick={() => setShowKnowledgeSelector(true)}
                className="flex items-center justify-center p-4 bg-white rounded-xl shadow-sm border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all text-left"
              >
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                  <MdLibraryBooks className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Utiliser vos connaissances</h4>
                  <p className="text-sm text-gray-500">Exploitez vos réponses précédentes</p>
                </div>
              </button>
            </div>
          </div>
        ) : (
          chatHistory.map((message, index) => (
            <div 
              key={index} 
              className={`flex ${message.type === "question" ? "justify-end" : "justify-start"} animate-fadeIn`}
            >
              <div 
                className={`max-w-[85%] rounded-2xl p-4 shadow-sm ${
                  message.type === "question" 
                    ? "bg-gradient-to-br from-blue-600 to-blue-700 text-white" 
                    : "bg-white text-gray-800 border border-gray-100"
                }`}
              >
                <div className="flex justify-between items-center mb-2">
                  <div className="text-xs font-medium flex items-center">
                    {message.type === "question" ? (
                      <>Vous</>
                    ) : (
                      <>
                        <MdAutoAwesome className="mr-1" /> Claude
                      </>
                    )}
                  </div>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(message.content);
                      toast.success("Copié dans le presse-papier!");
                    }}
                    className={`text-xs flex items-center ${
                      message.type === "question" ? "text-blue-200 hover:text-white" : "text-gray-500 hover:text-gray-700"
                    }`}
                  >
                    <MdOutlineContentCopy className="w-3 h-3 mr-1" />
                    Copier
                  </button>
                </div>
                <div className="whitespace-pre-wrap">{message.content}</div>
                
                {message.files && message.files.length > 0 && (
                  <div className={`mt-3 pt-2 ${message.type === "question" ? "border-t border-blue-500" : "border-t border-gray-200"}`}>
                    <div className={`text-xs mb-1 flex items-center ${message.type === "question" ? "text-blue-200" : "text-gray-500"}`}>
                      <MdDescription className="mr-1" /> Documents analysés:
                    </div>
                    <div className="flex flex-wrap gap-1">
                      {message.files.map((file) => (
                        <span 
                          key={file.id} 
                          className={`inline-block px-2 py-1 rounded-full text-xs ${
                            message.type === "question" 
                              ? "bg-blue-700 text-blue-100" 
                              : "bg-gray-100 text-gray-700"
                          }`}
                        >
                          {file.label}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                {message.knowledge && message.knowledge.length > 0 && (
                  <div className={`mt-3 pt-2 ${message.type === "question" ? "border-t border-blue-500" : "border-t border-gray-200"}`}>
                    <div className={`text-xs mb-1 flex items-center ${message.type === "question" ? "text-blue-200" : "text-gray-500"}`}>
                      <MdLibraryBooks className="mr-1" /> Connaissances utilisées:
                    </div>
                    <div className="flex flex-wrap gap-1">
                      {message.knowledge.map((item) => (
                        <span 
                          key={item.id} 
                          className={`inline-block px-2 py-1 rounded-full text-xs ${
                            message.type === "question" 
                              ? "bg-purple-700 text-blue-100" 
                              : "bg-purple-100 text-purple-700"
                          }`}
                        >
                          {item.label}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="text-xs mt-2 text-right opacity-70">
                  {new Date(message.timestamp).toLocaleTimeString()}
                </div>
              </div>
            </div>
          ))
        )}
        <div ref={chatEndRef} />
      </div>
      
      {/* Input Area */}
      <div className="bg-white border-t border-gray-200 p-4 md:p-6">
        <div className="max-w-4xl mx-auto">
          {/* Controls */}
          <div className="mb-3 flex flex-wrap gap-2">
            <button 
              onClick={() => setShowPromptLibrary(!showPromptLibrary)}
              className={`px-3 py-1.5 text-sm rounded-full flex items-center transition-colors ${
                showPromptLibrary 
                  ? "bg-blue-100 text-blue-700" 
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <MdLightbulb className="mr-1" />
              {showPromptLibrary ? "Masquer les prompts" : "Prompts"}
            </button>
            
            <button 
              onClick={() => setShowFileSelector(!showFileSelector)}
              className={`px-3 py-1.5 text-sm rounded-full flex items-center transition-colors ${
                showFileSelector || selectedFiles.length > 0
                  ? "bg-blue-100 text-blue-700" 
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <MdDescription className="mr-1" />
              {selectedFiles.length > 0 
                ? `${selectedFiles.length} document${selectedFiles.length > 1 ? 's' : ''}`
                : "Documents"}
            </button>
            
            <button 
              onClick={() => setShowKnowledgeSelector(!showKnowledgeSelector)}
              className={`px-3 py-1.5 text-sm rounded-full flex items-center transition-colors ${
                showKnowledgeSelector || selectedKnowledge.length > 0
                  ? "bg-purple-100 text-purple-700" 
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <MdLibraryBooks className="mr-1" />
              {selectedKnowledge.length > 0 
                ? `${selectedKnowledge.length} connaissance${selectedKnowledge.length > 1 ? 's' : ''}`
                : "Connaissances"}
            </button>
          </div>
          
          {/* Prompt Library */}
          {showPromptLibrary && (
            <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4 shadow-sm animate-fadeIn">
              <div className="text-sm font-medium text-gray-700 mb-3">Sélectionnez un prompt:</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {promptLibrary.map((prompt) => (
                  <button
                    key={prompt.id}
                    onClick={() => handlePromptChange(prompt.id)}
                    className={`text-left p-3 rounded-lg text-sm transition-all ${
                      selectedPromptId === prompt.id
                        ? "bg-blue-100 text-blue-800 shadow-sm"
                        : "bg-gray-50 text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                {prompt.label}
                  </button>
                ))}
              </div>
            </div>
          )}
          
          {/* File Selector */}
          {showFileSelector && (
            <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4 shadow-sm animate-fadeIn">
              <div className="flex justify-between items-center mb-3">
                <div className="text-sm font-medium text-gray-700">Documents disponibles:</div>
                <div className="flex items-center">
                  <input
                    type="text"
                    placeholder="Filtrer..."
                    value={fileFilter}
                    onChange={(e) => setFileFilter(e.target.value)}
                    className="text-sm border border-gray-300 rounded-full px-3 py-1 mr-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                  />
                  <button
                    onClick={handleSelectAllFiles}
                    className="text-xs text-blue-600 hover:text-blue-800"
                  >
                    {selectedFiles.length === filteredFiles.length && filteredFiles.length > 0 ? "Désélectionner tout" : "Sélectionner tout"}
                  </button>
                </div>
              </div>
              
              <div className="max-h-40 overflow-y-auto">
                {filteredFiles.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {filteredFiles.map((file) => (
                      <div 
                        key={file._id} 
                        onClick={() => handleFileSelection(file._id)}
                        className={`flex items-center p-2 rounded-lg cursor-pointer transition-colors ${
                          selectedFiles.includes(file._id)
                            ? "bg-blue-50 border border-blue-200"
                            : "hover:bg-gray-50 border border-transparent"
                        }`}
                      >
                        <input
                          type="checkbox"
                          id={`file-${file._id}`}
                          checked={selectedFiles.includes(file._id)}
                          onChange={() => {}} // Handled by parent div click
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <label htmlFor={`file-${file._id}`} className="ml-2 text-sm text-gray-700 cursor-pointer truncate flex-1">
                          {file.label}
                        </label>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-sm text-gray-500 text-center py-4">Aucun document correspondant</div>
                )}
              </div>
            </div>
          )}
          
          {/* Knowledge Selector */}
          {showKnowledgeSelector && (
            <div className="bg-white rounded-xl border border-gray-200 p-4 mb-4 shadow-sm animate-fadeIn">
              <div className="flex justify-between items-center mb-3">
                <div className="text-sm font-medium text-gray-700">Connaissances disponibles:</div>
                <div className="flex items-center">
                  <input
                    type="text"
                    placeholder="Filtrer..."
                    value={knowledgeFilter}
                    onChange={(e) => setKnowledgeFilter(e.target.value)}
                    className="text-sm border border-gray-300 rounded-full px-3 py-1 mr-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
                  />
                  {filteredKnowledge.length > 0 && (
                    <button
                      onClick={handleSelectAllKnowledge}
                      className="text-xs text-purple-600 hover:text-purple-800"
                    >
                      {selectedKnowledge.length === filteredKnowledge.length ? "Désélectionner tout" : "Sélectionner tout"}
                    </button>
                  )}
                </div>
              </div>
              
              <div className="max-h-40 overflow-y-auto">
                {filteredKnowledge.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {filteredKnowledge.map((item) => (
                      <div 
                        key={item._id} 
                        onClick={() => handleKnowledgeSelection(item._id)}
                        className={`flex items-center p-2 rounded-lg cursor-pointer transition-colors ${
                          selectedKnowledge.includes(item._id)
                            ? "bg-purple-50 border border-purple-200"
                            : "hover:bg-gray-50 border border-transparent"
                        }`}
                      >
                        <input
                          type="checkbox"
                          id={`knowledge-${item._id}`}
                          checked={selectedKnowledge.includes(item._id)}
                          onChange={() => {}} // Handled by parent div click
                          className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                        />
                        <div className="ml-2 flex-1 overflow-hidden">
                          <div className="text-sm text-gray-700 truncate">{item.label}</div>
                          {item.tags && item.tags.length > 0 && (
                            <div className="flex flex-wrap gap-1 mt-1">
                              {item.tags.slice(0, 2).map((tag, idx) => (
                                <span key={idx} className="inline-block px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded-full text-[10px]">
                                  {tag}
                                </span>
                              ))}
                              {item.tags.length > 2 && (
                                <span className="inline-block px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded-full text-[10px]">
                                  +{item.tags.length - 2}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : knowledgeItems.length === 0 ? (
                  <div className="text-sm text-gray-500 text-center py-4">
                    Aucune connaissance disponible. Ajoutez-en dans l'onglet "Base de connaissances".
                  </div>
                ) : (
                  <div className="text-sm text-gray-500 text-center py-4">Aucune connaissance correspondante</div>
                )}
              </div>
            </div>
          )}
          
          {/* Question Input */}
          <div className="flex items-end border border-gray-300 rounded-full focus-within:ring-2 focus-within:ring-blue-300 focus-within:border-blue-500 bg-white shadow-sm">
          <textarea
              ref={textareaRef}
              className="flex-1 p-4 text-gray-700 bg-transparent outline-none resize-none min-h-[24px] max-h-[200px] rounded-l-full"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Posez votre question..."
              rows={1}
          />
            <button
              className={`p-4 rounded-full ${
                isLoading || !question.trim()
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-white bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
              }`}
              onClick={handleAsk}
              disabled={isLoading || !question.trim()}>
              {isLoading ? (
                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
              ) : (
                <MdSend className="h-5 w-5" />
              )}
            </button>
        </div>

          <div className="text-xs text-gray-500 mt-2 text-center">
            Appuyez sur Entrée pour envoyer, Maj+Entrée pour un saut de ligne
          </div>
        </div>
      </div>
    </div>
  );
};

export default Claude;
